document.addEventListener('click', function (e) {
  var btn = e.target.closest('.size-to-cart');
  if (!btn || btn.disabled) return;

  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  var originalText = btn.innerText;

  btn.disabled = true;
  btn.innerText = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Network error');
      return res.json();
    })
        .then(function () {
      // Reload the page so the cart icon / mini-cart updates
      window.location.reload();
    })

    .catch(function (err) {
      console.error(err);
      btn.innerText = 'Error';
      setTimeout(function () {
        btn.innerText = originalText;
        btn.disabled = false;
      }, 1500);
    });
});
